import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'block'
  },
  formControl: {
    margin: theme.spacing(3),
    width: '100%',
    display: 'block'
  },
  linkSelectAllSmall: {
    fontWeight: '500',
    fontSize: '0.9em',
    textDecoration: 'underline'
  },
  linkClearAllSmall: {
    fontWeight: '500',
    fontSize: '0.9em',
    textDecoration: 'underline'
  },
  '@global': {
    '.MuiTypography-body1': {
      fontSize: 14
    }
  },
  checkboxArea: {
    width: '25%',
    maxWith: '25%',
    float: 'left'
  }
}));

export default useStyles;
